/*
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _tool = require("@entrylabs/tool");
var _extension = _interopRequireDefault(require("../../extensions/extension"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/*
 *
 */
Entry.FieldColor = /*#__PURE__*/function (_Entry$Field) {
  function FieldColor(content, blockView, index) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldColor);
    _this = _callSuper(this, FieldColor, [content, blockView, index]);
    (0, _defineProperty2["default"])(_this, "spoidClick", _.debounce(function () {
      _this.isRunSpoid = true;
      _this.colorPicker.data = {
        activeSpoid: true
      };
      var _ref = Entry.stage.canvas || {},
        canvas = _ref.canvas;
      _this.dropper.show({
        target: canvas
      }).once('pick', function (color) {
        var data = {
          activeSpoid: false
        };
        if (color) {
          _this.applyValue(color);
          data.color = color;
        }
        _this.colorPicker.setData(data);
        delete _this.isRunSpoid;
      });
    }));
    _this._block = blockView.block;
    _this._blockView = blockView;
    var board = blockView.getBoard();
    _this.box = new Entry.BoxModel();
    _this.svgGroup = null;
    _this._contents = content;
    _this._index = index;
    _this._position = content.position;
    _this._fontSize = content.fontSize || blockView.getSkeleton().fontSize || 10;
    _this._color = content.color || _this._block.getSchema().fontColor || blockView.getSkeleton().color || 'black';
    _this.key = content.key;
    _this.setValue(_this.getValue() || '#FF0000');
    _this._CONTENT_HEIGHT = _this.getContentHeight();
    _this._CONTENT_WIDTH = _this.getContentWidth();
    _this.renderStart();
    _this.dropper = _extension["default"].getExtension('Dropper');
    return _this;
  }
  (0, _inherits2["default"])(FieldColor, _Entry$Field);
  return (0, _createClass2["default"])(FieldColor, [{
    key: "renderStart",
    value: function renderStart() {
      if (this.svgGroup) {
        $(this.svgGroup).remove();
      }
      var _this$_blockView = this._blockView,
        contentSvgGroup = _this$_blockView.contentSvgGroup,
        renderMode = _this$_blockView.renderMode;
      this.svgGroup = contentSvgGroup.elem('g', {
        "class": 'entry-field-color'
      });
      var x, y, WIDTH, HEIGHT;
      if (renderMode === Entry.BlockView.RENDER_MODE_TEXT) {
        var rect = this.svgGroup.elem('rect', {
          x: 0,
          rx: 3,
          ry: 3,
          fill: '#fff',
          'fill-opacity': 0.4
        });
        this.textElement = this.svgGroup.elem('text').attr({
          style: 'white-space: pre;',
          'font-size': "".concat(this._fontSize, "px"),
          'font-family': EntryStatic.fontFamily || 'NanumGothic',
          "class": 'dragNone',
          fill: this._color
        });
        this.textElement.textContent = this._convert(this.getValue(), this.getValue());
        var bBox = this.textElement.getBoundingClientRect();
        WIDTH = bBox.width + 12;
        HEIGHT = bBox.height;
        rect.attr({
          y: -HEIGHT / 2,
          width: WIDTH,
          height: HEIGHT
        });
        this.textElement.attr({
          x: 6,
          y: bBox.height * 0.25
        });
      } else {
        HEIGHT = this._CONTENT_HEIGHT;
        WIDTH = this._CONTENT_WIDTH;
        var position = this._position;
        if (position) {
          x = position.x || 0;
          y = position.y || 0;
        } else {
          x = 0;
          y = -HEIGHT / 2;
        }
        this._header = this.svgGroup.elem('rect', {
          x: x,
          y: y,
          rx: 2,
          ry: 2,
          width: 20,
          //WIDTH,
          height: 20,
          //HEIGHT,
          fill: this.getValue(),
          stroke: '#fff',
          'stroke-width': '1'
        });
      }
      this._bindRenderOptions();
      this.box.set({
        x: x,
        y: y,
        width: WIDTH,
        height: HEIGHT
      });
    }
  }, {
    key: "_attachDisposeEvent",
    value: function _attachDisposeEvent(func) {
      var _this2 = this;
      var action = func;
      if (!action) {
        action = function action(skipCommand) {
          // this.applyValue(this.colorPicker.getData('color'));
          _this2.destroyOption(skipCommand);
          _this2._selectBlockView();
        };
      }
      this.disposeEvent = Entry.disposeEvent.attach(this, action);
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this3 = this;
      this.optionGroup = Entry.Dom('div', {
        "class": 'entry-color-picker',
        parent: $('body')
      });
      this.colorPicker = new _tool.ColorPicker({
        data: {
          eventTypes: ['mousedown', 'touchstart', 'wheel'],
          color: this.getValue(),
          canTransparent: false,
          canSpoide: true,
          positionDom: this.svgGroup,
          // boundrayDom: this.boundrayDom,
          onOutsideClick: function onOutsideClick(color) {
            if (_this3.isRunSpoid) {
              return;
            }
            if (_this3.colorPicker) {
              _this3.colorPicker.hide();
              color && _this3.applyValue(color);
            }
            _this3._attachDisposeEvent();
          },
          onSpoidClick: this.spoidClick
        },
        container: this.optionGroup[0]
      }).on('change', function (color) {
        if (color) {
          _this3.colorPicker.setData({
            color: color
          });
          _this3.applyValue(color);
        }
      });
      this.optionDomCreated();
    }
  }, {
    key: "applyValue",
    value: function applyValue(value) {
      if (this.value == value) {
        return;
      }
      this.setValue(value);
      if (this._header) {
        this._header.attr({
          fill: value
        });
      } else if (this.textElement) {
        value = this.getValue();
        this.textElement.textContent = this._convert(value, value);
      }
    }
  }, {
    key: "destroyOption",
    value: function destroyOption() {
      if (this.colorPicker) {
        this.colorPicker.isShow && this.colorPicker.hide();
        this.colorPicker.remove();
        this.colorPicker = null;
      }
      if (this.optionGroup) {
        this.optionGroup.remove();
      }
      _superPropGet(FieldColor, "destroyOption", this, 3)([]);
    }
  }, {
    key: "getContentWidth",
    value: function getContentWidth() {
      return 22;
    }
  }]);
}(Entry.Field);